import { render, staticRenderFns } from "./claimsProcess.vue?vue&type=template&id=116fd6de&scoped=true"
import script from "./claimsProcess.vue?vue&type=script&lang=js"
export * from "./claimsProcess.vue?vue&type=script&lang=js"
import style0 from "./claimsProcess.vue?vue&type=style&index=0&id=116fd6de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116fd6de",
  null
  
)

export default component.exports